import { gql, useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';

const offerQuery = gql`
  query getPriceFreezeOffer($offerRequest: PriceFreezeOfferRequest!)
  @ignore_update {
    itineraryPriceFreezeOffer(offerRequest: $offerRequest) {
      available
      offer {
        id
        expirationDate
        frozenPrimePrice {
          amount
          currency
        }
        deposit {
          amount
          currency
        }
        cap {
          amount
          currency
        }
      }
      searchCriteria {
        pax {
          numAdults
          numChildren
          numInfants
        }
      }
      itinerary {
        tripType
        legs {
          segments {
            carrier {
              id
              name
            }
            duration
            sections {
              transportType
              departureDate
              arrivalDate
              departure {
                name
                cityName
                countryCode
                iata
              }
              destination {
                name
                cityName
                countryCode
                iata
              }
            }
          }
        }
      }
    }
  }
`;

export function usePriceFreezeOfferQuery({
  searchId = '',
  fareItineraryKey = '',
  segmentKeys = [],
  lazyCondition = false,
}) {
  const data = useQuery(offerQuery, {
    variables: {
      offerRequest: {
        searchId: String(searchId),
        fareItineraryKey: String(fareItineraryKey),
        segmentKeys: segmentKeys.map((key) => Number(`${key}`.split(',')[0])),
      },
    },
    skip:
      !isValidInput(searchId, fareItineraryKey, segmentKeys) || lazyCondition,
  });

  useLogFrontendApiError(data);

  return data;
}

function isValidInput(searchId, fareItineraryKey, segmentKeys) {
  return (
    Number(searchId) > 0 &&
    Number(fareItineraryKey) >= 0 &&
    segmentKeys.map(Number).filter((key) => key >= 0).length ===
      segmentKeys.length
  );
}
